export default function SvgPdf() {
  return (
    <svg
      width="49"
      height="62"
      viewBox="0 0 49 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.125 0C2.75625 0 0.0306257 2.79 0.0306257 6.2L0 55.8C0 59.21 2.72562 62 6.09437 62H42.875C46.2438 62 49 59.21 49 55.8V18.6L30.625 0H6.125ZM27.5625 21.7V4.65L44.4062 21.7H27.5625Z"
        fill="#313131"
      />
    </svg>
  );
}
